import {ISystemAnnouncement} from '../../models/SystemAnnouncement';
import {makeAsyncReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {getSystemAnnouncement} from './systemAnnouncementActions';

export type SystemAnnouncementState = StateAsyncProperty<ISystemAnnouncement | null>;

export default makeAsyncReducer(getSystemAnnouncement);
